import React  from 'react';
import {useHistory} from "react-router-dom";
import ClayButton from '@clayui/button';
import {ClayInput, ClaySelect} from '@clayui/form';
import ClayForm from '@clayui/form';
import ClayIcon from '@clayui/icon';
import ClayModal, { useModal } from '@clayui/modal';
import ClayPanel from '@clayui/panel';
import {saveDetailProductSetting} from "../helpers/saveDetailProductSetting";

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const AddProduct = ({useAddProductModal}) => {

    const { addProductModal, setAddProductModal } = useAddProductModal();

    const { observer, onClose } = useModal({
        onClose: () => setAddProductModal({ ...setAddProductModal, visible: false })
    });

    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(document.getElementById('addProductForm'));

        const groupCode = formData.get("groupProductCode");

        saveDetailProductSetting(
            0, 
            groupCode,
            '',
            '',
            '',
            '',
            '',
            '',
            false,
            false,
            0,
            ''
        ).then(myobjet => {
            history.push(`detail/${myobjet.idSetting}`)
        });
    }

    return (
        <>
            {
                addProductModal.visible && (
                    <ClayModal
                        observer={observer}
                        size="lg"
                        spritemap={spritemap}
                        status="info" >
                        <form id="addProductForm" onSubmit={handleSubmit}>
                            <ClayModal.Body style={{maxHeight: "85vh"}}>
                                <ClayPanel
                                    collapsable
                                    displayTitle="Nuevo Producto"
                                    displayType="secondary"
                                    spritemap={spritemap}
                                    defaultExpanded >
                                    <ClayPanel.Body>
                                        <ClayForm.Group>
                                            <ClayInput.Group>
                                                <ClayInput.GroupItem>
                                                    <label htmlFor="newGroupProductCode">Grupo Producto
                                                        <span className="reference-mark">
                                                            <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                        </span>
                                                    </label>
                                                    <ClaySelect name="groupProductCode" id="type" required>
                                                        {
                                                            addProductModal.data && (
                                                                <>
                                                                    <ClaySelect.Option label="Seleccione" value='' />
                                                                    {
                                                                        addProductModal.data.map(item => (
                                                                            <ClaySelect.Option 
                                                                                key={item.childCode}
                                                                                label={item.childName}
                                                                                value={item.childCode}
                                                                            />
                                                                        ))
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </ClaySelect>
                                                </ClayInput.GroupItem>
                                            </ClayInput.Group>
                                        </ClayForm.Group>
                                    </ClayPanel.Body>             
                                </ClayPanel>
                            </ClayModal.Body>
                            <ClayModal.Footer
                                first={
                                    <ClayButton.Group spaced>
                                        <ClayButton onClick={onClose} displayType="secondary">{"Cancelar"}</ClayButton>
                                    </ClayButton.Group>
                                }
                                last={<ClayButton type="submit">{"Guardar"}</ClayButton>}
                            />
                        </form>
                    </ClayModal>
                )
            }
        </>
    )
}